/**
 * Returns true when the current page is being snapshotted by Puppeteer
 * during the SEO prerender build step (Puppeteer sets `navigator.webdriver`
 * to true by default).
 *
 * Wrap interactive chrome (audio players, floating drawers, bookmark
 * buttons, immersive-mode toggles, third-party widgets) with an
 * `if (isPrerendering()) return null` so the prerendered HTML stays lean
 * and the snapshot doesn't capture transient UI state. The same component
 * renders normally for real visitors after hydration.
 */
export function isPrerendering(): boolean {
  if (typeof navigator === 'undefined') return false
  return navigator.webdriver === true
}
